import {
    Color222 as respirationColor,
    ColorBlueLight2,
    ColorBluePrimary,
    ColorVioletPrimary,
    ColorVioletLight2,
    ColorVioletLight3,
    ColorPurpleDark1,
    ColorDarkuiAccent2,
    ColorTealPrimary,
    ColorPurpleLight2,
    Color409,
    ColorLightuiAccent1
} from 'ui-connect/styles/default-theme';
import { getFaqLink } from '../LinksUtil';

export const COLORS = {
    black: '#000000',
    white: '#ffffff',
    deep_sleep: ColorBluePrimary,
    light_sleep: ColorBlueLight2,
    rem_sleep: ColorVioletPrimary,
    total_sleep: ColorPurpleDark1,
    awake: ColorVioletLight2,
    stress: '#2a88e6',
    manually_entered: ColorBluePrimary,
    unmeasurable: 'transparent',
    grey_1: '#282828',
    grey_2: '#C5C5C5',
    grey_3: '#E6E6E6',
    grey_4: '#F9F9F9',
    pulse_ox: '#9E9E9E',
    blue_1: '#11a9ed',
    blue_2: '#67C7F2',
    blue_3: '#BFE7F8',
    blue_4: '#76ccf3',
    backgroundChart: '#6D8595',
    respiration: respirationColor,
    restlessness: ColorBlueLight2,
    restlessness_updated: ColorDarkuiAccent2,
    skinTempReport: ColorVioletLight3,
    sleepScoreReport: ColorPurpleLight2,
    respirationReport: ColorTealPrimary,
    sleepDuration: ColorBluePrimary,
    sleepNeed: ColorLightuiAccent1,
    goalReached: Color409,
    restingHeartRateReport: ColorBlueLight2,
    bodyBatteryChangeReport: ColorBlueLight2,
    sleepConsistencyReport: ColorBluePrimary
};

export const AVAILABLE_TABS = {
    levels: 'tab_levels',
    score: 'tab_score',
    pulseOx: 'tab_pulseOx',
    respiration: 'tab_respiration'
};

export const AVAILABLE_CHARTS = {
    levels: 'chart_levels',
    breathingVariations: 'chart_breathingVariations',
    movement: 'chart_movement',
    restlessMoments: 'chart_sleepRestlessMoments',
    heartRate: 'chart_heartRate',
    bodyBattery: 'chart_bodyBattery',
    pulseOx: 'chart_pulseOx',
    respiration: 'chart_respiration',
    overnightHrv: 'chart_overnightHrv'
};

export const AVAILABLE_REPORTS_CHARTS = {
    skinTemp: {
        type: 'chart_skinTemp',
        translation_ns: 'sleep_skin_temp',
        translation_key: 'skin_temp_change'
    },
    pulseOx: {
        type: 'chart_pulseOx',
        translation_ns: 'units',
        translation_key: 'label_pulse_ox'
    },
    respiration: {
        type: 'chart_respiration',
        translation_ns: 'units',
        translation_key: 'label_respiration'
    },
    restingHeartRate: {
        type: 'chart_restingHeartRate',
        translation_ns: 'daily_summary',
        translation_key: 'resting_heart_rate'
    },
    bodyBatteryChange: {
        type: 'chart_bodyBatteryChange',
        translation_ns: 'bodybattery',
        translation_key: 'body_battery'
    },
    hrvStatus: {
        type: 'chart_hrvStatus',
        translation_ns: 'hrv_status',
        translation_key: 'card_type_hrvStatus'
    }
};

export const LEVELS_CHART_NORMALIZED_VALUE = 0.35;

export const MAX_SLEEP_SCORE = 100;

export const MAX_NR_OF_NAPS = 8;

export const SLEEP_SCORE_FACTORS = {
    total_sleep: {
        key: 'total_sleep',
        translation_ns: 'wellness',
        translation_key: 'sleep_duration'
    },
    stress: {
        key: 'stress',
        translation_ns: 'stress',
        translation_key: 'label_stress'
    },
    deep_sleep: {
        key: 'deep_sleep',
        translation_ns: 'wellness',
        translation_key: 'deep'
    },
    light_sleep: {
        key: 'light_sleep',
        translation_ns: 'wellness',
        translation_key: 'light'
    },
    rem_sleep: {
        key: 'rem_sleep',
        translation_ns: 'wellness',
        translation_key: 'rem'
    },
    awake: {
        key: 'awake',
        translation_ns: 'wellness',
        translation_key: 'awake_time',
        idealDuration: 300
    },
    restlessness: {
        key: 'restlessness',
        translation_ns: 'wellness',
        translation_key: 'restlessness'
    }
};

export const SLEEP_TIME_EDITOR_TYPES = {
    sleep: 'sleep',
    awake: 'awake'
};

export const sleepScoreKeysNoGenericInsight = [
    'POSITIVE_SHORT_BUT_RECOVERING',
    'POSITIVE_SHORT_BUT_DEEP',
    'POSITIVE_SHORT_BUT_REFRESHING',
    'POSITIVE_SHORT_BUT_CONTINUOUS',
    'POSITIVE_SHORT_BUT_CALM',
    'NEGATIVE_LIGHT'
];

export const excludedSleepScorePersonalizedInsightKeys = [
    'GENERAL_POS_EXCELLENT_OR_GOOD_SLEEP',
    'GENERAL_POS_FAIR_OR_POOR_SLEEP',
    'GENERAL_NEG_EXCELLENT_OR_GOOD_SLEEP',
    'GENERAL_NEG_FAIR_OR_POOR_SLEEP'
];

// the same keys are excluded for Header Tip and Recommandation
export const sleepCoachKeysNoHeaderTip = [
    'EVENT_DAY_POS_EXCELLENT_SLEEP',
    'EVENT_DAY_POS_GOOD_SLEEP',
    'EVENT_DAY_POS_FAIR_SLEEP_GOOD_DURATION',
    'EVENT_DAY_POS_FAIR_SLEEP_NOTGOOD_DURATION',
    'EVENT_DAY_POS_POOR_SLEEP',
    'EVENT_DAY_NEG_GOOD_SLEEP',
    'EVENT_DAY_NEG_FAIR_SLEEP_GOOD_DURATION',
    'EVENT_DAY_NEG_FAIR_SLEEP_NOTGOOD_DURATION',
    'EVENT_DAY_NEG_POOR_SLEEP',
    'AFTER_EVENT_DAY_POS_EXCELLENT_OR_GOOD_SLEEP',
    'AFTER_EVENT_DAY_POS_FAIR_SLEEP_GOOD_DURATION',
    'AFTER_EVENT_DAY_POS_FAIR_SLEEP_NOTGOOD_DURATION',
    'AFTER_EVENT_DAY_POS_POOR_SLEEP',
    'AFTER_EVENT_DAY_NEG_GOOD_SLEEP',
    'AFTER_EVENT_DAY_NEG_FAIR_SLEEP_GOOD_DURATION',
    'AFTER_EVENT_DAY_NEG_FAIR_SLEEP_NOTGOOD_DURATION',
    'AFTER_EVENT_DAY_NEG_POOR_SLEEP',
    'HARD_EXERCISE_POS_EXCELLENT_OR_GOOD_SLEEP_STRENUOUS_DURING_DAY',
    'HARD_EXERCISE_POS_EXCELLENT_OR_GOOD_SLEEP_HARD_TO_STRENUOUS_DURING_DAY_OUTDOOR',
    'HARD_EXERCISE_POS_FAIR_SLEEP_HARD_TO_STRENUOUS_DURING_DAY_OUTDOOR',
    'HARD_EXERCISE_POS_EXCELLENT_OR_GOOD_SLEEP_HARD_DURING_DAY',
    'HARD_EXERCISE_POS_FAIR_SLEEP_HARD_TO_STRENUOUS_DURING_DAY',
    'MOD_EXERCISE_POS_EXCELLENT_OR_GOOD_SLEEP_RELAX_CLOSE_BED',
    'MOD_EXERCISE_POS_EXCELLENT_OR_GOOD_SLEEP_ACTIVE_DAY',
    'MOD_EXERCISE_POS_EXCELLENT_OR_GOOD_SLEEP_VIGOROUS_DURING_DAY_OUTDOOR',
    'MOD_EXERCISE_POS_EXCELLENT_OR_GOOD_SLEEP_MODERATE_DURING_DAY_OUTDOOR',
    'MOD_EXERCISE_POS_FAIR_SLEEP_MOD_TO_VIG_DURING_DAY_OUTDOOR',
    'MOD_EXERCISE_POS_EXCELLENT_OR_GOOD_SLEEP_VIGOROUS_CLOSE_BED',
    'MOD_EXERCISE_POS_EXCELLENT_OR_GOOD_SLEEP_MODERATE_CLOSE_BED',
    'MOD_EXERCISE_POS_EXCELLENT_OR_GOOD_SLEEP_VIGOROUS_DURING_DAY',
    'MOD_EXERCISE_POS_EXCELLENT_OR_GOOD_SLEEP_MODERATE_DURING_DAY',
    'MOD_EXERCISE_POS_FAIR_SLEEP_MOD_TO_VIG_DURING_DAY',
    'ALTITUDE_POS_EXCELLENT_OR_GOOD_SLEEP',
    'ALTITUDE_POS_FAIR_SLEEP',
    'NAPPING_NEG_GOOD_SLEEP_GOOD_DURATION_INTERRUPTED',
    'NAPPING_NEG_GOOD_SLEEP_GOOD_DURATION_RESTLESS',
    'NAPPING_NEG_FAIR_SLEEP_GOOD_DURATION_UNBALANCED',
    'NAPPING_NEG_FAIR_SLEEP_GOOD_DURATION_INTERRUPTED',
    'NAPPING_NEG_FAIR_SLEEP_GOOD_DURATION_RESTLESS',
    'NAPPING_NEG_FAIR_SLEEP_GOOD_DURATION_POOR_QUALITY',
    'NAPPING_NEG_FAIR_SLEEP_NOTGOOD_DURATION_UNBALANCED',
    'NAPPING_NEG_FAIR_SLEEP_NOTGOOD_DURATION_INTERRUPTED',
    'NAPPING_NEG_FAIR_SLEEP_NOTGOOD_DURATION_RESTLESS',
    'NAPPING_NEG_FAIR_SLEEP_NOTGOOD_DURATION_POOR_QUALITY',
    'NAPPING_POS_POOR_SLEEP_NOTGOOD_DURATION',
    'NAPPING_NEG_POOR_SLEEP_UNBALANCED',
    'NAPPING_NEG_POOR_SLEEP_DISTURBED',
    'NAPPING_NEG_POOR_SLEEP_POOR_QUALITY',
    'PREGNANCY_1TRIM_POS_GOOD_OR_WORSE_SLEEP_GOOD_DURATION',
    'PREGNANCY_1TRIM_NEG_GOOD_OR_WORSE_SLEEP_POOR_RECOVERY',
    'PREGNANCY_1TRIM_NEG_GOOD_OR_WORSE_SLEEP_LOW_DEEP',
    'PREGNANCY_2TRIM_POS_GOOD_OR_WORSE_SLEEP_GOOD_DURATION',
    'PREGNANCY_2TRIM_NEG_GOOD_OR_WORSE_SLEEP_POOR_RECOVERY',
    'PREGNANCY_2TRIM_NEG_GOOD_OR_WORSE_SLEEP_LOW_DEEP',
    'PREGNANCY_2TRIM_NEG_GOOD_OR_WORSE_SLEEP_LOW_REM',
    'PREGNANCY_3TRIM_POS_GOOD_OR_WORSE_SLEEP_GOOD_DURATION',
    'PREGNANCY_3TRIM_NEG_GOOD_OR_WORSE_SLEEP_POOR_RECOVERY',
    'PREGNANCY_3TRIM_NEG_GOOD_OR_WORSE_SLEEP_LOW_DEEP',
    'PREGNANCY_3TRIM_NEG_GOOD_OR_WORSE_SLEEP_LOW_REM',
    'PREGNANCY_POSTP_POS_EXCELLENT_OR_WORSE_SLEEP_GOOD_RECOVERY',
    'PREGNANCY_POSTP_POS_GOOD_OR_WORSE_SLEEP_HIGH_DEEP',
    'PREGNANCY_POSTP_POS_GOOD_OR_WORSE_SLEEP_HIGH_REM',
    'PREGNANCY_POSTP_NEG_GOOD_OR_WORSE_SLEEP_POOR_RECOVERY',
    'PREGNANCY_POSTP_NEG_GOOD_OR_WORSE_SLEEP_HIGH_INTERRUPTED',
    'PREGNANCY_POSTP_NEG_GOOD_OR_WORSE_SLEEP_NOTGOOD_DURATION_POOR_QUALITY',
    'RHYTHM_POS_EXCELLENT_SLEEP_EXCELLENT_TIMING',
    'RHYTHM_POS_EXCELLENT_SLEEP_GOOD_TIMING',
    'RHYTHM_POS_GOOD_SLEEP_EXCELLENT_TIMING',
    'RHYTHM_POS_GOOD_SLEEP_GOOD_TIMING',
    'RHYTHM_POS_FAIR_OR_POOR_SLEEP_GOOD_TIMING',
    'STRESS_POS_EXCELLENT_OR_GOOD_SLEEP_VERY_RESTFUL_DAY',
    'STRESS_POS_EXCELLENT_OR_GOOD_SLEEP_RESTFUL_DAY',
    'STRESS_POS_FAIR_OR_POOR_SLEEP_RESTFUL_DAY',
    'STRESS_POS_EXCELLENT_OR_GOOD_SLEEP_RESTFUL_EVENING',
    'STRESS_POS_FAIR_OR_POOR_SLEEP_RESTFUL_EVENING'
];

export const SLEEP_SCORE_FEEDBACK = {
    POSITIVE_HIGHLY_RECOVERING: {
        learnMoreTranslationKey: 'sleep_score_learn_more_national_foundation',
        learnMoreLink:
            'https://www.sleepfoundation.org/excessive-sleepiness/performance/good-nights-sleep-helps-job-performance'
    },
    POSITIVE_OPTIMAL_STRUCTURE: {
        learnMoreTranslationKey: 'sleep_score_learn_more_national_foundation',
        learnMoreLink: 'https://www.sleepfoundation.org/how-sleep-works/what-happens-when-you-sleep'
    },
    POSITIVE_LONG_AND_RECOVERING: {
        learnMoreTranslationKey: 'sleep_score_learn_more_american_association',
        learnMoreLink: 'https://www.apa.org/monitor/2017/10/cover-sleep'
    },
    POSITIVE_LONG_AND_DEEP: {
        learnMoreTranslationKey: 'sleep_score_learn_more_national_foundation',
        learnMoreLink: 'https://www.sleep.org/articles/what-happens-during-sleep/'
    },
    POSITIVE_LONG_AND_REFRESHING: {
        learnMoreTranslationKey: 'sleep_score_learn_more_national_foundation',
        learnMoreLink: 'https://www.sleep.org/articles/what-happens-during-sleep/'
    },
    POSITIVE_LONG_AND_CONTINUOUS: {
        learnMoreTranslationKey: 'sleep_score_learn_more_national_foundation',
        learnMoreLink: 'https://www.sleepfoundation.org/sleep-deprivation/interrupted-sleep'
    },
    POSITIVE_LONG_AND_CALM: {
        learnMoreTranslationKey: 'sleep_score_learn_more_mental_health',
        learnMoreLink: 'https://www.mhanational.org/rest-relaxation-and-exercise'
    },
    POSITIVE_RECOVERING: {
        learnMoreTranslationKey: 'sleep_score_learn_more_mayo_clinic',
        learnMoreLink:
            'https://www.mayoclinic.org/healthy-lifestyle/adult-health/in-depth/sleep-the-foundation-for-healthy-habits/art-20270117'
    },
    POSITIVE_DEEP: {
        learnMoreTranslationKey: 'sleep_score_learn_more_national_foundation',
        learnMoreLink: 'https://www.sleep.org/articles/what-happens-during-sleep/'
    },
    POSITIVE_REFRESHING: {
        learnMoreTranslationKey: 'sleep_score_learn_more_national_foundation',
        learnMoreLink: 'https://www.sleep.org/articles/what-happens-during-sleep/'
    },
    POSITIVE_CONTINUOUS: {
        learnMoreTranslationKey: 'sleep_score_learn_more_national_foundation',
        learnMoreLink: 'https://www.sleep.org/articles/interrupted-sleep-what-happens-to-your-body/'
    },
    POSITIVE_CALM: {
        learnMoreTranslationKey: 'sleep_score_learn_more_arthritis_foundation',
        learnMoreLink:
            'https://www.arthritis.org/health-wellness/healthy-living/managing-pain/fatigue-sleep/sleep-and-pain'
    },
    POSITIVE_SHORT_BUT_RECOVERING: {
        learnMoreTranslationKey: 'sleep_score_learn_more_national_foundation',
        learnMoreLink: 'https://www.sleepfoundation.org/articles/healthy-sleep-tips'
    },
    POSITIVE_SHORT_BUT_DEEP: {
        learnMoreTranslationKey: 'sleep_score_learn_more_mayo_clinic',
        learnMoreLink: 'https://www.mayoclinic.org/healthy-lifestyle/adult-health/in-depth/sleep/art-20048379'
    },
    POSITIVE_SHORT_BUT_REFRESHING: {
        learnMoreTranslationKey: 'sleep_score_learn_more_national_foundation',
        learnMoreLink: 'https://www.sleepfoundation.org/sleep-hygiene/healthy-sleep-tips'
    },
    POSITIVE_SHORT_BUT_CONTINUOUS: {
        learnMoreTranslationKey: 'sleep_score_learn_more_national_foundation',
        learnMoreLink: 'https://www.sleepfoundation.org/insomnia/treatment/what-do-when-you-cant-sleep'
    },
    POSITIVE_SHORT_BUT_CALM: {
        learnMoreTranslationKey: 'sleep_score_learn_more_national_foundation',
        learnMoreLink: 'https://www.sleepfoundation.org/bedroom-environment/technology-in-the-bedroom'
    },
    NEGATIVE_LONG_BUT_NOT_RESTORATIVE: {
        learnMoreTranslationKey: 'sleep_score_learn_more_mayo_clinic',
        learnMoreLink: 'https://www.mayoclinic.org/healthy-lifestyle/adult-health/in-depth/sleep/art-20048379'
    },
    NEGATIVE_LONG_BUT_LIGHT: {
        learnMoreTranslationKey: 'sleep_score_learn_more_american_association_2',
        learnMoreLink: 'https://www.sleepassociation.org/about-sleep/stages-of-sleep/deep-sleep/'
    },
    NEGATIVE_LONG_BUT_NOT_REFRESHING: {
        learnMoreTranslationKey: 'sleep_score_learn_more_national_foundation',
        learnMoreLink: ' https://www.sleepfoundation.org/insomnia/treatment/what-do-when-you-cant-sleep'
    },
    NEGATIVE_LONG_BUT_DISCONTINUOUS: {
        learnMoreTranslationKey: 'sleep_score_learn_more_american_academy',
        learnMoreLink:
            'https://www.sleepfoundation.org/excessive-sleepiness/performance/good-nights-sleep-helps-job-performance'
    },
    NEGATIVE_LONG_BUT_RESTLESS: {
        learnMoreTranslationKey: 'sleep_score_learn_more_national_foundation',
        learnMoreLink: 'https://www.sleepfoundation.org/sleep-deprivation/interrupted-sleep'
    },
    NEGATIVE_LONG_BUT_POOR_QUALITY: {
        learnMoreTranslationKey: 'sleep_score_learn_more_national_foundation',
        learnMoreLink: ' https://www.sleepfoundation.org/sleep-hygiene/healthy-sleep-tips'
    },
    NEGATIVE_NOT_RESTORATIVE: {
        learnMoreTranslationKey: 'sleep_score_learn_more_mayo_clinic',
        learnMoreLink: 'https://www.mayoclinic.org/healthy-lifestyle/adult-health/in-depth/sleep/art-20048379'
    },
    NEGATIVE_LIGHT: {
        learnMoreTranslationKey: 'sleep_score_learn_more_american_association_2',
        learnMoreLink: 'https://www.sleepassociation.org/about-sleep/stages-of-sleep/deep-sleep/'
    },
    NEGATIVE_NOT_REFRESHING: {
        learnMoreTranslationKey: 'sleep_score_learn_more_mayo_clinic',
        learnMoreLink: 'https://www.mayoclinic.org/healthy-lifestyle/adult-health/in-depth/sleep/art-20048379'
    },
    NEGATIVE_DISCONTINUOUS: {
        learnMoreTranslationKey: 'sleep_score_learn_more_american_academy',
        learnMoreLink:
            'https://www.sleepfoundation.org/excessive-sleepiness/performance/good-nights-sleep-helps-job-performance'
    },
    NEGATIVE_RESTLESS: {
        learnMoreTranslationKey: 'sleep_score_learn_more_national_foundation',
        learnMoreLink: 'https://www.sleepfoundation.org/insomnia/treatment/what-do-when-you-cant-sleep'
    },
    NEGATIVE_POOR_STRUCTURE: {
        learnMoreTranslationKey: 'sleep_score_learn_more_mayo_clinic',
        learnMoreLink: 'https://www.mayoclinic.org/healthy-lifestyle/adult-health/in-depth/sleep/art-20048379'
    },
    NEGATIVE_SHORT_AND_NONRECOVERING: {
        learnMoreTranslationKey: 'sleep_score_learn_more_american_academy',
        learnMoreLink: 'http://sleepeducation.org/essentials-in-sleep/healthy-sleep-habits'
    },
    NEGATIVE_SHORT_AND_POOR_STRUCTURE: {
        learnMoreTranslationKey: 'sleep_score_learn_more_national_foundation',
        learnMoreLink: 'https://www.sleepfoundation.org/sleep-hygiene/healthy-sleep-tips'
    },
    NEGATIVE_SHORT_AND_POOR_QUALITY: {
        learnMoreTranslationKey: 'sleep_score_learn_more_national_foundation',
        learnMoreLink: 'https://www.sleep.org/improve-your-sleep/'
    },
    NEGATIVE_LONG_BUT_NOT_ENOUGH_REM: {
        learnMoreTranslationKey: 'sleep_score_learn_more_national_foundation',
        learnMoreLink: 'https://www.sleepfoundation.org/insomnia/treatment/what-do-when-you-cant-sleep'
    },
    NEGATIVE_LONG_BUT_TOO_MUCH_REM: {
        learnMoreTranslationKey: 'sleep_score_learn_more_university_1',
        learnMoreLink: 'https://www.sciencedaily.com/releases/2019/01/190128101104.htm'
    },
    NEGATIVE_NOT_ENOUGH_REM: {
        learnMoreTranslationKey: 'sleep_score_learn_more_mayo_clinic',
        learnMoreLink: 'https://www.mayoclinic.org/healthy-lifestyle/adult-health/in-depth/sleep/art-20048379'
    },
    NEGATIVE_TOO_MUCH_REM: {
        learnMoreTranslationKey: 'sleep_score_learn_more_university_2',
        learnMoreLink: 'https://www.pennmedicine.org/news/news-releases/2016/june/weight-and-diet-may-help-predi'
    }
};

export const SLEEP_SCORE_FEEDBACK_CONFIG = {
    POSITIVE_HIGHLY_RECOVERING: {
        genericGuidanceMissing: true
    },
    POSITIVE_LONG_AND_RECOVERING: {
        longFeedbackMissing: true
    },
    POSITIVE_LONG_AND_DEEP: {
        longFeedbackMissing: true
    },
    POSITIVE_LONG_AND_REFRESHING: {
        longFeedbackMissing: true
    },
    POSITIVE_LONG_AND_CONTINUOUS: {
        longFeedbackMissing: true
    },
    POSITIVE_LONG_AND_CALM: {
        longFeedbackMissing: true
    },
    POSITIVE_REFRESHING: {
        genericGuidanceMissing: true
    }
};

export const SLEEP_DATA_ACCURACY_LINK = getFaqLink('qvzNMwxuTb9NxZ6Ce2a9z9');

export const SLEEP_REPORT_CONFIG = {
    CHART_52_WEEKS_LENGTH: 13,
    SCORE_YEAR_REPORT_WEEKS_COUNT: 52
};

export const RESTLESS_MOMENTS_FREQUENCY_IN_MINUTES = 3;
export const RESPIRATION_FREQUENCY_IN_MINUTES = 2;
export const AVERAGE_RESPIRATION_FREQUENCY_IN_MINUTES = 60;
export const PULSE_OX_FREQUENCY_IN_MINUTES = 1;
export const HEART_RATE_FREQUENCY_IN_MINUTES = 2;
export const BODY_BATTERY_FREQUENCY_IN_MINUTES = 3;
export const OVERNIGHT_HRV_FREQUENCY_IN_MINUTES = 5;
export const BREATHING_VARIATIONS_FREQUENCY_IN_MINUTES = 1;

export const LEVELS_CHART_Y_AXIS_LABELS = ['deep', 'light', 'rem', 'awake'];
export const BREATHING_VARIATIONS_Y_AXIS_LABELS = ['minimal_short', 'few', 'occasional', 'frequent'];

export const BREATHING_METRICS_LABELS = {
    NONE: {
        translation_ns: 'wellness',
        translation_key: 'minimal'
    },
    LOW: {
        translation_ns: 'wellness',
        translation_key: 'few'
    },
    MEDIUM: {
        translation_ns: 'device',
        translation_key: 'label_occasional'
    },
    HIGH: {
        translation_ns: 'device',
        translation_key: 'label_frequent'
    },
    UNMEASURABLE: {
        translation_ns: 'wellness',
        translation_key: 'unmeasurable'
    }
};

export const SLEEP_DURATION_GOAL = 28800; // Number of seconds in 8 hours; currently a constant per requirements

export const SKIN_TEMP_MIN_MAX_VALUES = {
    MIN_C: -20,
    MIN_F: -36,
    MAX_C: 20,
    MAX_F: 36
};

export const SLEEP_HELP_SECTION_TYPES = {
    score: 'score',
    coach: 'coach'
};

export const SLEEP_COACH_FACTOR_TYPES = {
    SleepHistory: 'SleepHistory',
    ActivityHistory: 'ActivityHistory',
    HrvStatus: 'HrvStatus',
    Naps: 'Naps'
};

export const sleepCoachNoChangeFeedbackKeys = ['NO_CHANGE_BALANCED', 'NO_CHANGE_NO_ADJUSTMENTS', 'NONE'];
export const SLEEP_COACH_NON_CONTRIBUTING_FACTOR_TYPES = ['NO_CHANGE', 'NO_DATA'];

export const SLEEP_CHART_TABS = {
    timeline: 'timeline',
    stages: 'stages'
};

export const SLEEP_QUALIFIER_KEYS = {
    INVALID: 'INVALID'
};

export const BREATHING_VARIATIONS = {
    none: 0,
    few: 1,
    occasional: 2,
    frequent: 3,
    unmeasurable: 255
};

export const BREATHING_VARIATIONS_METRICS = {
    UNMEASURABLE: 'UNMEASURABLE'
};
